import React from "react";

import Show from "./show";

import { connect } from "react-redux";
import {
    load,
    getData,
    isLoading,
    isLoaded,
    getError,
    isSecondaryLoading,
    updatePaymentMethod,
    deletePaymentMethod,
    createStorageFolder,
    postVendorBitacoraMessage,
    validatePrices,
    rejectPrices,
    validatePaymentMethod,
    rejectPaymentMethod,
    createEventNotAvailable,
    dismissEvent,
    updatePriority,
} from "../../../../redux/actions/manager/vendor/show";

import {
    initStorage,
    isStorageAvailable,
    getStorageData,
    isStorageLoading,
} from "../../../../redux/actions/common/storage/init";

import {
    CACHE_PRIORITY,
    CACHE_SERVICE,
    CACHE_SPECIALIZATION,
    CACHE_UNIT,
    CACHE_COUNTRY,
    CACHE_CURRENCY,
    CACHE_LANGUAGE,
    CACHE_LANGUAGE_PAIR,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getCurrenciesForSelect,
    getCountriesForSelect,
    getLanguagesForSelect,
    getLanguagesById,
    getCountriesById,
    getLanguagePairsForSelect,
    getSpecializationsForSelect,
    getServicesForSelect,
    getServicesById,
    getUnitsForSelect,
    getUnitsById,
    getLanguagePairsById,
    getCategoriesById,
    getSpecializationsById,
} from "../../../../redux/actions/cache/interface";

import { getPrioritiesForSelect } from "../../../../redux/actions/cache/priority";

import Loader from "../../../../components/loader";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    /**
     * Parametros
     *  - id:  Se asume que el ID viene por la URL
     */
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    componentDidMount() {
        this.props.load(this.state.id);
        this.props.loadCache();
        this.props.initStorage();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    render() {
        const { loading, data, loaded } = this.props;
        return (
            <>
                <Loader loading={this.props.loading || this.props.actionLoading} />
                {!loading && loaded && data && <Show data={this.props.data} {...this.props} />}
            </>
        );
    }
}

const cacheList = [
    CACHE_PRIORITY,
    CACHE_SERVICE,
    CACHE_SPECIALIZATION,
    CACHE_UNIT,
    CACHE_COUNTRY,
    CACHE_CURRENCY,
    CACHE_LANGUAGE,
    CACHE_LANGUAGE_PAIR,
];

function MapStateToProps(state) {
    return {
        error: getError(state),
        data: getData(state),

        loading: isLoading(state) || isCacheLoading(state, cacheList),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),

        countries: getCountriesForSelect(state),
        countriesById: getCountriesById(state),
        currencies: getCurrenciesForSelect(state),
        specializations: getSpecializationsForSelect(state),
        specializationsById: getSpecializationsById(state),
        languagePairs: getLanguagePairsForSelect(state),
        languagePairsById: getLanguagePairsById(state),
        languages: getLanguagesForSelect(state),
        languagesById: getLanguagesById(state),
        units: getUnitsForSelect(state),
        unitsById: getUnitsById(state),
        services: getServicesForSelect(state),
        servicesById: getServicesById(state),
        categoriesById: getCategoriesById(state),

        priorities: getPrioritiesForSelect(state),

        actionLoading: isSecondaryLoading(state),

        storageAvailable: isStorageAvailable(state),
        storageData: getStorageData(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        load: (id) => dispatch(load(id)),
        updatePriority: (id, form) => dispatch(updatePriority(id, form)),
        updatePaymentMethod: (id, form) => dispatch(updatePaymentMethod(id, form)),
        deletePaymentMethod: (vendorId) => (id) => dispatch(deletePaymentMethod(vendorId, id)),
        createStorageFolder: (id) => dispatch(createStorageFolder(id)),
        createEventNotAvailable: (id, form) => dispatch(createEventNotAvailable(id, form)),
        dismissEvent: (id, eventId) => dispatch(dismissEvent(id, eventId)),
        postVendorBitacoraMessage: (id) => (form) => dispatch(postVendorBitacoraMessage(id, form)),
        validatePrices: (id) => dispatch(validatePrices(id)),
        rejectPrices: (id) => dispatch(rejectPrices(id)),
        validatePaymentMethod: (id) => dispatch(validatePaymentMethod(id)),
        rejectPaymentMethod: (id) => dispatch(rejectPaymentMethod(id)),
        loadCache: () => loadCache(cacheList)(dispatch),
        initStorage: () => dispatch(initStorage()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
